import { ReactNode } from 'react'

import { Currency, CurrencyAmount } from '@cowprotocol/currency'
import { TokenLogo } from '@cowprotocol/tokens'
import { TokenAmount } from '@cowprotocol/ui'

import { Nullish } from 'types'

import { PriceImpact } from 'legacy/hooks/usePriceImpact'

import * as styledEl from './styled'

import { FiatValue } from '../FiatValue'

export interface CurrencyPreviewInfo {
  amount: Nullish<CurrencyAmount<Currency>>
  fiatAmount: Nullish<CurrencyAmount<Currency>>
  balance: Nullish<CurrencyAmount<Currency>>
  label?: Nullish<string>
}

export interface CurrencyPreviewProps extends Partial<BuiltItProps> {
  id: string
  currencyInfo: CurrencyPreviewInfo
  isBridging?: boolean
  priceImpactParams?: PriceImpact
}

interface BuiltItProps {
  className: string
}

export function CurrencyAmountPreview(props: CurrencyPreviewProps): ReactNode {
  const { id, currencyInfo, className, priceImpactParams, isBridging } = props
  const { fiatAmount, amount } = currencyInfo
  const topLabel = currencyInfo.label
  const currency = amount?.currency

  return (
    <styledEl.Container id={id} className={className}>
      <div>{topLabel}</div>
      <div>
        <styledEl.TokenLogoWrapper>
          <TokenLogo token={currency} size={42} />
        </styledEl.TokenLogoWrapper>
      </div>
      <styledEl.Amount>
        <TokenAmount className="token-amount-input" amount={amount} tokenSymbol={currency} />
        <FiatValue fiatValue={fiatAmount} priceImpactParams={priceImpactParams} isBridging={isBridging} />
      </styledEl.Amount>
    </styledEl.Container>
  )
}
